import { Box, Typography } from "@mui/material"
import { CustomPaper } from "../../../../../../../components/CustomPaper"
import { getStatus } from "../../../../../../../hooks/status"
import { Status } from "../../../../../../../utils/enums"
import { useTranslation } from "react-i18next"
import { useContextState } from "../../../../../../../hooks/theme"
import { useStyles } from "./styles"


export const StatusCard = ({ count, type }: { count: number, type: Status }) => {

    const { t } = useTranslation()
    const { colors } = useContextState()
    const statusLocale = getStatus(type, colors, t)
    const styles = useStyles()
    const isNoFinisf = type === Status.NOT_FINISHED ? true : false;
    const colorNoFinish = colors.color13

    return (
        <CustomPaper sx={styles.statusCount} elevation={2}>
            <Typography variant="text_grey" fontWeight='bold' sx={styles.number}>{count}</Typography>
            <Box sx={styles.circle( isNoFinisf ? colorNoFinish : statusLocale.color)} />
            <Typography variant="text_grey" fontWeight='500'>{statusLocale.text}</Typography>
        </CustomPaper>
    )
}